import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as core from '../../../core'

export enum PrimeSponsorType {
  Foundation = 'foundation',
  StateOrStrictFederal = 'state-or-strict-federal',
  FederalContract = 'federal-contract',
  CorporateFederalFlowdown = 'corporate-federal-flowdown',
  GoCo = 'goco',
  ForeignOrStringent = 'foreign-or-stringent',
}

const PRIME_SPONSOR_TYPES: ReadonlySet<PrimeSponsorType> = new Set(
  Object.values(PrimeSponsorType) as PrimeSponsorType[],
)
export namespace PrimeSponsorType {
  export const ALL: readonly PrimeSponsorType[] =
    Array.from(PRIME_SPONSOR_TYPES)
  export const isPrimeSponsorType =
    TypeChecker.Factory.oneOf(PRIME_SPONSOR_TYPES)
  export const assertIsPrimeSponsorType: TypeAsserter<PrimeSponsorType> =
    TypeAsserter.Factory.from(isPrimeSponsorType)

  /**
   * Returns the {@link core.common.value.types.Enum.Entry} for the given
   * {@link PrimeSponsorType}
   */
  export function getEntry(
    primeSponsorType: PrimeSponsorType,
  ): core.common.value.types.Enum.Entry {
    return { ...ENTRY_LOOKUP[primeSponsorType], id: primeSponsorType }
  }
  /** Used by {@link getEntry} */
  const ENTRY_LOOKUP: Record<
    PrimeSponsorType,
    Omit<core.common.value.types.Enum.Entry, 'id'>
  > = {
    [PrimeSponsorType.Foundation]: {
      name: 'Foundation or Routine Granting Agency',
    },
    [PrimeSponsorType.StateOrStrictFederal]: {
      name: 'State, Corporate, or more stringent Federal Sponsor',
    },
    [PrimeSponsorType.FederalContract]: {
      name: 'Federal Contracting Agency',
    },
    [PrimeSponsorType.CorporateFederalFlowdown]: {
      name: 'Corporate Sponsor flowing down Federal Prime',
    },
    [PrimeSponsorType.GoCo]: {
      name: 'Government Owned/Contractor Operated',
    },
    [PrimeSponsorType.ForeignOrStringent]: {
      name: 'Foreign sponsor or other very stringent sponsor (from any funding source)',
    },
  }
}
